/* eslint-disable max-len */
import React from 'react'
import MonitorPatientTable from './PatientTable'

function MonitorPatientList({user_id,
    data,
    patientAssociatedTrigger,
    isFetching,
    providerData,
    status,
    setIsProviderAddOrDelete,
    handleDeleteAssociatedPatient,
    fetchPageAndLimit,
    queryParams,
    setQueryParams,
    pageItems,
    setPageItems

}) {
    return (
        <div className='bg-[#00000008] rounded-lg px-2 mb-[28px]'>
            <p id={'provider_patient_dattest'} className='text-base font-semibold text-[#972E4C] px-1.5 py-[22px] '>Patient List</p>
            <MonitorPatientTable 
                user_id={user_id}
                data={data}
                providerData={providerData}
                patientAssociatedTrigger={patientAssociatedTrigger}
                status={status}
                isFetching={isFetching}
                setIsProviderAddOrDelete={setIsProviderAddOrDelete}
                handleDeleteAssociatedPatient={handleDeleteAssociatedPatient}
                fetchPageAndLimit={fetchPageAndLimit}
                queryParams={queryParams}
                setQueryParams={setQueryParams}
                pageItems={pageItems}
                setPageItems={setPageItems}
            />    
        </div>
    )
}

export default MonitorPatientList